/*----------------------------------------------------------------------------*\
    Navigation
    Simple, accesible navigation object
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};
oy.navigation = oy.navigation || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */



/*  Component
\*----------------------------------------------------------------------------*/

oy.navigation.main = {
    init: function(){
        if (oy.cutsMustard) {
            // Your javascript
            this.setupAll(document);
        }
    },

    setupAll: function ($context) {
        var self = this;
        var $elements = $context.querySelectorAll('.js--nav-main:not(.is-initialised)');

        for (var i = 0; i < $elements.length; ++i) {
            var $element = $elements[i];
            self.setupSingle($element);
        }
    },

    setupSingle: function ($context) {
        // var self = this;
        var $toggle = $context.querySelector('.js--nav-main__toggle');
        var $page = document.querySelector('.js--nav-main__page');

        if ($toggle !== null) {
            $toggle.addEventListener('click', function() {
                if ($page.classList.contains('is-menu-open')) {
                    $toggle.classList.remove('is-active');
                    $page.classList.remove('is-menu-open');
                } else {
                    $toggle.classList.add('is-active');
                    $page.classList.add('is-menu-open');
                }
            });
        }
    }
};


window.addEventListener('load', function () {
    oy.navigation.main.init();
}, false);
